import { For, Match, Show, Switch, createEffect, createMemo } from "solid-js";
import { MentorsCard } from "./components/mentors-card";
import { solidstate } from ":setup/qstate";
import { mentors } from "./apis";
import { Loader2 } from ":src/components/loaders";
import { createInput, createSelect } from ":ui/form";

export default function Mentors() {
  const $list = solidstate.createAsync(mentors.get);
  const $applied_filter = solidstate.create({} as { search?: string; track?: string });
  const $filters = createMemo(() => {
    const result = {
      search: ["name", "track"],
      tracks: [],
    };
    const list = $list.value;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const track = item.track;
      if (!result.tracks.includes(track)) {
        result.tracks.push(track);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterTracks = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const track = FilterTracks.control.value;
    $applied_filter.set((s) => ({ ...s, track: track }));
  });

  return (
    <section class="flex flex-col w-full min-h-full h-full px-5 py-3 gap-2 <md:(px-2 py-1)">
      <h1 class="text-xl  font-[600] text-black z-1 <md:(text-22px )">Meet Your Mentors</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterTracks.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Track..."
          options={$filters().tracks}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$list.state.loading}>
          <Loader2 msg="Loading Mentors..." />
        </Match>
        <Match when={$list.state.failed}>an error occurred while fetching {$list.error}</Match>
        <Match when={$list.state.success}>
          <div class="grid grid-cols-3 gap-4 h-fit  overflow-x-hidden !overflow-y-auto py-5 scrollbar <sm:(grid-cols-1 !py-1)">
            <For each={$list.value}>
              {(item) => {
                const show = createMemo(() => {
                  const search_keywords = $filters().search;
                  const search = $applied_filter?.value?.search?.toLowerCase?.();
                  const track = $applied_filter?.value?.track;
                  if (
                    search != undefined &&
                    !search_keywords.some((prop) => item[prop]?.toLowerCase().includes(search))
                  ) {
                    return false;
                  }
                  if (track != undefined && item?.track !== track) {
                    if (track === "undefined" && item.track == undefined) {
                      return true;
                    }
                    return false;
                  }

                  return true;
                });
                return (
                  <Show when={show()}>
                    <MentorsCard {...item} />
                  </Show>
                );
              }}
            </For>
          </div>
        </Match>
      </Switch>
    </section>
  );
}
